export const TIME_INTERVAL = ['24h', 'today', 'yesterday', 'week', 'month'];
export const LAST_24H = '24h';
export const TODAY = 'today';
export const YESTERDAY = 'yesterday';
export const WEEK = 'week';
export const MONTH = 'month';

export const DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';